import React from 'react';
import {t} from '@lingui/core/macro';

import {IPayment} from 'entities/payment';

import Box from '../../../shared/ui/Box/Box';

import LinkButton from '../../../shared/ui/Button/LinkButton/LinkButton';
import {AppUrls} from '../../../shared/config/model/urls';

import styles from './Payments.module.scss';

interface IPaymentSuccessProps {
    item: IPayment
}

const PaymentSuccess: React.FC<IPaymentSuccessProps> = ({item}) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.box_wrapper}>
                <Box>
                    <div className="row text-center mb-3">
                        <div className="col-12">
                            <h2 className="mb-3">{t`Успешная оплата`}</h2>
                            <div className={styles.text}>
                                {`${t`Вы успешно оплатили тариф`} "${item.tariff.name}"`}
                            </div>
                        </div>
                    </div>

                    <LinkButton
                        href={AppUrls.PAYMENTS}
                        primary
                        block
                    >
                        {t`Продолжить`}
                    </LinkButton>
                </Box>
            </div>
        </div>
    );
};

export default PaymentSuccess;